import React from 'react';

const Col2Component = ({ title, description, imageProfile, signatureName }) => {
  return (
    <div className="m-8 grid grid-cols-1 md:grid-cols-2 gap-4">

      <div className="flex justify-center items-center">
        <img src={imageProfile} alt={title} className="w-60 h-60 rounded-full shadow-lg object-cover" style={{ objectPosition: 'center -40px' }} />
      </div>
      <div className="flex flex-col justify-center">
        <div className="p-5 pb-2">
          <h1 className='font-bold text-4xl text-secondary mb-2'>{title}</h1>
          {signatureName && (
            <p className="text-3xl text-gray-600 mb-2" style={{ fontFamily: '"Caveat", "Kalam", "Indie Flower", cursive', letterSpacing: '0.02em', transform: 'rotate(-0.5deg)' }}>
              {signatureName}
            </p>
          )}
        </div>
        <p className="px-5 pt-2">{description}</p>
      </div>    
    </div>
  );
};

export default Col2Component;
